var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 22,
    height: 22,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h22v22H0V0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 11,
    fill: "rgb(255,255,255)",
    rx: 2.933,
    ry: 2.933
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M6.57250977 3.66668701L8.25 1.83334351h5.5l1.67749023 1.8333435H18.333313c1.00836181 0 1.83331299.8249817 1.83331299 1.83331299v11c0 1.0083313-.82495118 1.8333435-1.833313 1.8333435h-14.666687c-1.00830078 0-1.833313-.8250122-1.833313-1.8333435v-11c0-1.0083313.82501222-1.83331299 1.833313-1.83331299h2.90588379zM6.416687 11c0 2.52999878 2.05334473 4.58331299 4.58331299 4.58331299 2.5300293 0 4.58337402-2.05331421 4.58337402-4.58331299 0-2.52999878-2.05334472-4.5833435-4.58337402-4.5833435-2.52996826 0-4.58331299 2.05334472-4.58331299 4.5833435z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.756581fd7b06f80ca8adfd6a5a979eb3.svg";
export { ForwardRef as ReactComponent };